import { ReactNode } from "react"

/**
 * First mobile, second desktop
 * @param props
 * @constructor
 */
function MobileAlternative(props: { children: ReactNode }) {
    return (
        <>
            {!Array.isArray(props.children) && <>{props.children}</>}
            {(props.children as ReactNode[]).length === 2 && (
                <>
                    <div className={"w-full sm:hidden"}>
                        {(props.children as ReactNode[])[0]}
                    </div>
                    <div className={"w-full hidden sm:flex"}>
                        {(props.children as ReactNode[])[1]}
                    </div>
                </>
            )}
        </>
    )
}

export default MobileAlternative
